export function apenasNumeros(valor = "") {
  return String(valor || "").replace(/\D/g, "");
}

export function decimalInputValido(valor = "") {
  return valor === "" || /^\d+([.,]\d{0,2})?$/.test(valor);
}

export function normalizarDecimal(valor = "") {
  return String(valor || "").replace(",", ".");
}

export function paraNumero(valor = "") {
  if (valor === null || valor === undefined || valor === "") return 0;
  return Number(String(valor).replace(",", ".")) || 0;
}

export function formatarMoeda(valor = 0, moeda = "BRL") {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: moeda,
  });
}

export function formatarData(dataIso) {
  if (!dataIso) return "-";
  const data = new Date(dataIso);
  return data.toLocaleDateString("pt-BR");
}

export function formatarDataHora(dataIso) {
  if (!dataIso) return "-";
  const data = new Date(dataIso);
  return data.toLocaleString("pt-BR");
}